import React, { useState } from 'react';
import { useKeenSlider } from 'keen-slider/react';
import 'keen-slider/keen-slider.min.css';
import { ArrowUp, ArrowDown } from 'lucide-react';
import FlowingMeshCanvas from '../FlowingMeshCanvasAlt';

const offerData = [
    {
        id: 1,
        title: "Life At Mobikode",
        description: "At Mobikode, excellence is simply how we work every day. We believe in open conversations, sharing ideas, and working together to create something meaningful, while ensuring both our clients and our team grow, succeed, and feel valued.",
        image: "/assets/career/img8.jpg",
    },
    {
        id: 2,
        title: "Career Growth",
        description: "We truly care about your growth. That’s why we create clear career paths, offer supportive mentorship, and provide learning opportunities like workshops and certifications, so you feel confident, supported, and ready to grow at every stage of your journey.",
        image: "/assets/career/img8.jpg",
    },
    {
        id: 3,
        title: "Global Exposure",
        description: "At Mobikode, you’ll work with people from different parts of the world, collaborate on global projects, and gain real experience that helps you grow and stand out in the tech industry.",
        image: "/assets/career/img8.jpg",
    },
];

const WhatWeOffer = () => {
    const [currentSlide, setCurrentSlide] = useState(0);
    const [loaded, setLoaded] = useState(false);

    const [sliderRef, instanceRef] = useKeenSlider({
        initial: 0,
        direction: "vertical",
        loop: true,
        slides: {
            origin: "center",
            perView: 1,
            spacing: 20,
        },
        slideChanged(slider) {
            setCurrentSlide(slider.track.details.rel);
        },
        created() {
            setLoaded(true);
        },
    });

    return (
        <section className="w-full pt-16 lg:pt-[100px] bg-white overflow-hidden relative">
            <div
                className="absolute top-[-200px] right-[-200px] w-[500px] h-[500px] rotate-[-60deg] lg:w-[800px] lg:h-[800px] z-0 pointer-events-none opacity-80"
                style={{
                    maskImage: 'radial-gradient(circle at top right, black 40%, transparent 70%)',
                    WebkitMaskImage: 'radial-gradient(circle at top right, black 40%, transparent 70%)'
                }}
            >
                <FlowingMeshCanvas />
            </div>
            <div className="max-w-[1440px] mx-auto px-[20px] lg:px-[80px]">

                <h2 className="text-[#01386A] text-[20px] md:text-[30px] font-[600] font-sora mb-[46px] text-left">
                    What We Offer You
                </h2>

                <div className="flex flex-col lg:flex-row bg-[#F1F1F1] relative z-20 gap-8 lg:gap-[36px] p-[33px] h-full">
                    <div className="hidden lg:flex flex-col justify-center gap-4 z-20">
                        <button
                            onClick={(e) => e.stopPropagation() || instanceRef.current?.prev()}
                            className="w-[32px] h-[32px] rounded-full border border-[#ED6800] text-[#ED6800] hover:bg-[#ED6800] hover:text-white flex items-center justify-center transition-all duration-300"
                        >
                            <ArrowUp size={16} />
                        </button>
                        <button
                            onClick={(e) => e.stopPropagation() || instanceRef.current?.next()}
                            className="w-[32px] h-[32px] rounded-full border border-[#ED6800] text-[#ED6800] hover:bg-[#ED6800] hover:text-white flex items-center justify-center transition-all duration-300"
                        >
                            <ArrowDown size={16} />
                        </button>
                    </div>

                    <div ref={sliderRef} className="keen-slider h-full w-full relative">
                        {offerData.map((item) => (
                            <div key={item.id} className="keen-slider__slide h-full w-full flex items-center justify-center">
                                <div className="relative w-full h-[395px] flex items-center">
                                    <div className="absolute top-0 right-0 w-full lg:w-[586px] h-full bg-gray-100 overflow-hidden">
                                        <img
                                            src={item.image}
                                            alt={item.title}
                                            className="w-full h-full object-cover mix-blend-multiply"
                                        />
                                    </div>

                                    <div className="relative z-20 w-full lg:w-full max-w-[618px] bg-white shadow-[0_10px_40px_rgba(0,0,0,0.1)] p-[20px] lg:p-[45px] border-b-4 border-[#01386A]">
                                        <h3 className="text-[#01386A] text-[16px] lg:text-[20px] font-[600] font-sora lg:mb-[35px] mb-[20px]">
                                            {item.title}
                                        </h3>
                                        <p className="text-[#49577A] max-w-[432px] w-full text-[14px] lg:text-[16px] leading-[1.6] font-graphik font-[500] text-justify">
                                            {item.description}
                                        </p>
                                    </div>

                                </div>

                            </div>
                        ))}
                    </div>

                    <div className="flex lg:hidden justify-center gap-4 mt-4">
                        <button
                            onClick={(e) => e.stopPropagation() || instanceRef.current?.prev()}
                            className="w-10 h-10 rounded-full border border-[#ED6800] text-[#ED6800] flex items-center justify-center"
                        >
                            <ArrowUp className="-rotate-90" size={20} />
                        </button>
                        <button
                            onClick={(e) => e.stopPropagation() || instanceRef.current?.next()}
                            className="w-10 h-10 rounded-full border border-[#ED6800] text-[#ED6800] flex items-center justify-center"
                        >
                            <ArrowDown className="-rotate-90" size={20} />
                        </button>
                    </div>

                </div>
            </div>
        </section>
    );
};

export default WhatWeOffer;